import FreeBusyCacheManager from './FreeBusyCacheManager';

const pageSizeInDays = 28;
const cacheSize = 10;
const freeBusyCache = new FreeBusyCacheManager(pageSizeInDays, cacheSize);

export default freeBusyCache;
